// extracted by mini-css-extract-plugin
module.exports = {"phase-list":"phase-list__3Lfgo","add":"add__15c2P","edit":"edit__T9oS9"};